import React, { useState } from 'react';
import { format } from 'date-fns';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

const ReportGenerator = ({ reportData, detailedData, generateReport, startDate, endDate }) => {
  const [localStartDate, setLocalStartDate] = useState(startDate);
  const [localEndDate, setLocalEndDate] = useState(endDate);

  const handleGenerate = () => {
    generateReport(localStartDate, localEndDate);
  };

  return (
    <div className="p-4 bg-white rounded-lg shadow">
      <h2 className="text-xl font-bold mb-4">Attendance Report</h2>

      <div className="flex flex-col md:flex-row gap-4 mb-6">
        <div className="w-full md:w-48">
          <label className="block text-sm font-medium mb-1">Start Date</label>
          <DatePicker
            selected={localStartDate}
            onChange={setLocalStartDate}
            className="w-full p-2 border rounded"
            dateFormat="dd/MM/yyyy"
          />
        </div>
        <div className="w-full md:w-48">
          <label className="block text-sm font-medium mb-1">End Date</label>
          <DatePicker
            selected={localEndDate}
            onChange={setLocalEndDate}
            className="w-full p-2 border rounded"
            dateFormat="dd/MM/yyyy"
          />
        </div>
        <div className="flex items-end">
          <button
            onClick={handleGenerate}
            className="bg-[#AB3430] text-white px-6 py-2 rounded hover:bg-[#8a2b28] h-[42px]"
          >
            Generate Report
          </button>
        </div>
      </div>

      {reportData && (
        <div className="mt-4">
          <h3 className="font-bold mb-2">
            Report from {format(new Date(localStartDate), 'dd/MM/yyyy')} to {format(new Date(localEndDate), 'dd/MM/yyyy')}
          </h3>

          <div className="overflow-x-auto">
            <table className="w-full border-collapse">
              <thead className="bg-gray-100">
                <tr>
                  <th className="p-3 text-left">Staff Member</th>
                  <th className="p-3 text-left">Days Present</th>
                  <th className="p-3 text-left">Days Absent</th>
                  <th className="p-3 text-left">Attendance %</th>
                </tr>
              </thead>
              <tbody>
                {reportData.map((item) => (
                  <tr key={item._id} className="border-b hover:bg-gray-50">
                    <td className="p-3">{item.name}</td>
                    <td className="p-3">{item.presentDays}</td>
                    <td className="p-3">{item.absentDays}</td>
                    <td className="p-3">
                      {item.totalDays > 0
                        ? ((item.presentDays / item.totalDays) * 100).toFixed(2)
                        : '0.00'}%
                    </td>
                  </tr>
                ))}

              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
};

export default ReportGenerator;